import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const RadioRoundIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M12.005 23q-2.28 0-4.29-.866a11.1 11.1 0 0 1-3.495-2.35 11.1 11.1 0 0 1-2.353-3.49A10.7 10.7 0 0 1 1 12.005q0-2.28.866-4.29a11.1 11.1 0 0 1 2.35-3.495 11.1 11.1 0 0 1 3.49-2.353A10.7 10.7 0 0 1 11.996 1q2.28 0 4.29.866 2.01.865 3.495 2.35t2.353 3.49Q23 9.714 23 11.996q0 2.28-.866 4.29a11.1 11.1 0 0 1-2.35 3.495q-1.485 1.485-3.49 2.353a10.7 10.7 0 0 1-4.289.867M12 22.115q4.236 0 7.175-2.94T22.115 12t-2.94-7.175T12 1.885t-7.175 2.94T1.885 12t2.94 7.175T12 22.115"
    />
  </BaseIcon>
)
